import { defaultSounds } from '@pascal/pascal-core/shared/core/services/sound/defaultSounds';
import { SoundService as BaseSoundService, SoundType as BaseSoundTypes } from '@pascal/pascal-core';

defaultSounds.music.loop = true;
// defaultSounds.winn = null;

const SoundTypes = {
  ...BaseSoundTypes,
  sharkComing: 'sharkComing',
  winBeep: 'winBeep',
  fishComing: 'fishComing',
};

const options = [
  {
    name: SoundTypes.winBeep,
    src: `winBeep.mp3`,
    autoplay: false,
    html5: true,
    loop: false,
  },
  {
    src: 'sharkComing.mp3',
    name: SoundTypes.sharkComing,
    autoplay: false,
    html5: true,
    loop: false,
  },
  {
    src: 'fishComing.mp3',
    name: SoundTypes.fishComing,
    autoplay: false,
    html5: true,
    loop: false,
  },
];

class SoundService extends BaseSoundService {
  constructor(props) {
    super(props);
  }
}

const soundService = new SoundService({
  options,
});

export { SoundTypes as soundTypes, soundService };
